import { Cached } from "@mui/icons-material";
import BusinessIcon from '@mui/icons-material/Business';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import SellIcon from '@mui/icons-material/Sell';
import ApartmentIcon from '@mui/icons-material/Apartment';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import ViewComfyIcon from '@mui/icons-material/ViewComfy';
import ClearIcon from '@mui/icons-material/Clear';
import { Box, Button, Divider, Drawer, IconButton, styled, Typography, Link, Tabs, Tab } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import ItemInformation from "./ItemInformation";
import FinancialDetails from "./FinancialDetail";
import Physical from "./Physical";
import MEP from "./MEP";
import TechConnection from "./TechConnection";
import moment from "moment";
import { apiRequest } from "../../../../../common/common";
import { showNotification } from "../../../../../common/Notification/ToastifyNotification";
import { LoadingPage } from "../../../../../common/LoadingPage";
import { handleUndefined } from "../../../../../common/const";
import Responsibilities from "./Responsibility";

const DemoBox1 = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '5px 5px 5px 15px'
}));

const EditItem = ({
    open,
    setOpen,
    itemData,
    projectData,
    getInitialData
}) => {
    const [selectedTab, setSelectedTab] = useState(0);
    const [dataLoading, setDataLoading] = useState(false);
    const contentRef = useRef(null);
    const [items, setItems] = useState({
        alternate_description: itemData?.alternate_description || `${itemData?.product?.category?.name || ''}, ${itemData?.product?.["sub_category"]?.name || ''}`,
        notes: itemData?.notes,
        unit_price: itemData?.unit_price,
        quantity: itemData?.quantity,
        scope: itemData?.scope,
        stage: itemData?.stage,
        status: itemData?.status,
        freight: itemData.freight,
        fees: itemData?.fees,
        storage: itemData?.storage,
        installation: itemData?.installation,
        discounts: itemData?.discounts,
        tradein: itemData?.tradein,
        funding_source: itemData?.funding_source,
        budget_id: itemData?.budget_id,
        default_tax_from_project: itemData?.default_tax_from_project,
        tax: itemData?.default_tax_from_project ? projectData?.tax_rate : itemData?.tax,
        is_tax_exempt: projectData?.is_tax_exempt,
        phase_id: itemData?.phase_id,
        phase_date: itemData?.phase_date !== null ? moment(itemData?.phase_date).format('YYYY-MM-DD') : null,
        bid_group_id: itemData?.bid_group_id,
        cost_centre_id: itemData?.cost_centre_id,
        manufacturer: {
            name: handleUndefined(itemData?.manufacturer?.name, itemData?.product?.manufacturer?.name)
        },
        manufacturer_id: handleUndefined(itemData?.manufacturer?.product_provider_id, itemData?.product?.manufacturer?.product_provider_id),
        need_by_date: moment(itemData?.need_by_date).format('YYYY-MM-DD'),
        product_id: itemData?.product_id,
        product_data: {
            vendor_id: handleUndefined(itemData?.product_data?.vendor_id, itemData?.product?.vendor?.product_provider_id),
            vendor: {
                name: handleUndefined(itemData?.product_data?.vendor?.name, itemData?.product?.vendor?.name)
            },
            catalog: handleUndefined(itemData?.product_data?.catalog, itemData?.product?.catalog),
            custom_id_1: itemData?.product_data?.custom_id_1,
            custom_id_2: itemData?.product_data?.custom_id_2,
            alternate_id: itemData?.product_data?.alternate_id,
            govt_id: itemData?.product_data?.govt_id,
            inventory_id: itemData?.product_data?.inventory_id,
            model: handleUndefined(itemData?.product_data?.model, itemData?.product?.model),
            from_project: itemData?.product_data?.from_project || true,
            price_type: handleUndefined(itemData?.product_data?.price_type, itemData?.product?.price_type),
            type: handleUndefined(itemData?.product_data?.type, itemData?.product?.type),
            life_expectancy: handleUndefined(itemData?.product_data?.life_expectancy, itemData?.product?.life_expectancy),
            lead_time: handleUndefined(itemData?.product_data?.lead_time, itemData?.product?.lead_time),
            furnish_responsibility: handleUndefined(itemData?.product_data?.furnish_responsibility, itemData?.product?.furnish_responsibility),
            install_responsibility: handleUndefined(itemData?.product_data?.install_responsibility, itemData?.product?.install_responsibility),
            architectural_code: handleUndefined(itemData?.product_data?.architectural_code, itemData?.product?.architectural_code),
            international: handleUndefined(itemData?.product_data?.international, itemData?.product?.international),
            architecturally_significant: handleUndefined(itemData?.product_data?.architecturally_significant, itemData?.product?.architecturally_significant),
            spatially_significant: handleUndefined(itemData?.product_data?.spatially_significant, itemData?.product?.spatially_significant),
            tech_connection_data: {
                isConnection: handleUndefined(itemData?.product_data?.tech_connection_data?.isConnection, itemData?.product?.tech_connection_data?.isConnection),
                connectionType: handleUndefined(itemData?.product_data?.tech_connection_data?.connectionType, itemData?.product?.tech_connection_data?.connectionType),
                network: handleUndefined(itemData?.product_data?.tech_connection_data?.network, itemData?.product?.tech_connection_data?.network),
                techRemarks: handleUndefined(itemData?.product_data?.tech_connection_data?.techRemarks, itemData?.product?.tech_connection_data?.techRemarks)
            },
            description: handleUndefined(itemData?.product_data?.description, itemData?.product?.description),
            adjustable_width: handleUndefined(itemData?.product_data?.adjustable_width, itemData?.product?.adjustable_width),
            adjustable_height: handleUndefined(itemData?.product_data?.adjustableHeight, itemData?.product?.adjustable_height),
            adjustable_depth: handleUndefined(itemData?.product_data?.adjustable_depth, itemData?.product?.adjustable_depth),
            width: handleUndefined(itemData?.product_data?.width, itemData?.product?.width),
            height: handleUndefined(itemData?.product_data?.height, itemData?.product?.height),
            depth: handleUndefined(itemData?.product_data?.depth, itemData?.product?.depth),
            mounting: handleUndefined(itemData?.product_data?.mounting, itemData?.product?.mounting),
            max_weight: handleUndefined(itemData?.product_data?.max_weight, itemData?.product?.max_weight),
            ship_weight: handleUndefined(itemData?.product_data?.ship_weight, itemData?.product?.ship_weight),
            clearance: {
                left: handleUndefined(itemData?.product_data?.clearance?.left, itemData?.product?.clearance?.left),
                right: handleUndefined(itemData?.product_data?.clearance?.right, itemData?.product?.clearance?.right),
                front: handleUndefined(itemData?.product_data?.clearance?.front, itemData?.product?.clearance?.front),
                back: handleUndefined(itemData?.product_data?.clearance?.back, itemData?.product?.clearance?.back),
                top: handleUndefined(itemData?.product_data?.clearance?.top, itemData?.product?.clearance?.top),
                bottom: handleUndefined(itemData?.product_data?.clearance?.bottom, itemData?.product?.clearance?.bottom)
            },
            da_complient: handleUndefined(itemData?.product_data?.da_complient, itemData?.product?.da_complient),
            antimicrobial: handleUndefined(itemData?.product_data?.antimicrobial, itemData?.product?.antimicrobial),
            green: handleUndefined(itemData?.product_data?.green, itemData?.product?.green),
            seismic: handleUndefined(itemData?.product_data?.seismic, itemData?.product?.seismic),
            Shielding: handleUndefined(itemData?.product_data?.Shielding, itemData?.product?.Shielding),
            spatial_remarks: handleUndefined(itemData?.product_data?.spatial_remarks, itemData?.product?.spatial_remarks),
            mechanical_data: {
                heatDissipation: handleUndefined(itemData?.product_data?.mechanical_data?.heatDissipation, itemData?.product?.mechanical_data?.heatDissipation),
                dissipationType: handleUndefined(itemData?.product_data?.mechanical_data?.dissipationType, itemData?.product?.mechanical_data?.dissipationType),
                vent: handleUndefined(itemData?.product_data?.mechanical_data?.vent, itemData?.product?.mechanical_data?.vent),
                ventType: handleUndefined(itemData?.product_data?.mechanical_data?.ventType, itemData?.product?.mechanical_data?.ventType),
                mechanicalRemarks: handleUndefined(itemData?.product_data?.mechanical_data?.mechanicalRemarks, itemData?.product?.mechanical_data?.mechanicalRemarks)
            },
            electrical_data: {
                voltageType: handleUndefined(itemData?.product_data?.electrical_data?.voltageType, itemData?.product?.electrical_data?.voltageType),
                volts: handleUndefined(itemData?.product_data?.electrical_data?.volts, itemData?.product?.electrical_data?.volts),
                amps: handleUndefined(itemData?.product_data?.electrical_data?.amps, itemData?.product?.electrical_data?.amps),
                hertz: handleUndefined(itemData?.product_data?.electrical_data?.hertz, itemData?.product?.electrical_data?.hertz),
                watts: handleUndefined(itemData?.product_data?.electrical_data?.watts, itemData?.product?.electrical_data?.watts),
                kva: handleUndefined(itemData?.product_data?.electrical_data?.kva, itemData?.product?.electrical_data?.kva),
                electricalPhase: handleUndefined(itemData?.product_data?.electrical_data?.electricalPhase, itemData?.product?.electrical_data?.electricalPhase),
                plugtype: handleUndefined(itemData?.product_data?.electrical_data?.plugtype, itemData?.product?.electrical_data?.plugtype),
                plugdetail: handleUndefined(itemData?.product_data?.electrical_data?.plugdetail, itemData?.product?.electrical_data?.plugdetail),
                dedicatedCircuit: handleUndefined(itemData?.product_data?.electrical_data?.dedicatedCircuit, itemData?.product?.electrical_data?.dedicatedCircuit),
                emergencyPower: handleUndefined(itemData?.product_data?.electrical_data?.emergencyPower, itemData?.product?.electrical_data?.emergencyPower),
                remoteTrans: handleUndefined(itemData?.product_data?.electrical_data?.remoteTrans, itemData?.product?.electrical_data?.remoteTrans),
                remoteSwitch: handleUndefined(itemData?.product_data?.electrical_data?.remoteSwitch, itemData?.product?.electrical_data?.remoteSwitch),
                electricalRemarks: handleUndefined(itemData?.product_data?.electrical_data?.electricalRemarks, itemData?.product?.electrical_data?.electricalRemarks)
            },
            plumbing_data: {
                plumbingRemarks: handleUndefined(itemData?.product_data?.plumbing_data?.plumbingRemarks, itemData?.product?.plumbing_data?.plumbingRemarks),
                hotWater: handleUndefined(itemData?.product_data?.plumbing_data?.hotWater, itemData?.product?.plumbing_data?.hotWater),
                coldWater: handleUndefined(itemData?.product_data?.plumbing_data?.coldWater, itemData?.product?.plumbing_data?.coldWater),
                treatedWater: handleUndefined(itemData?.product_data?.plumbing_data?.treatedWater, itemData?.product?.plumbing_data?.treatedWater),
                drain: handleUndefined(itemData?.product_data?.plumbing_data?.drain, itemData?.product?.plumbing_data?.drain),
                drainLocation: handleUndefined(itemData?.product_data?.plumbing_data?.drainLocation, itemData?.product?.plumbing_data?.drainLocation),
                steam: handleUndefined(itemData?.product_data?.plumbing_data?.steam, itemData?.product?.plumbing_data?.steam),
                vaccumMedical: handleUndefined(itemData?.product_data?.plumbing_data?.vaccumMedical, itemData?.product?.plumbing_data?.vaccumMedical),
                vaccumDental: handleUndefined(itemData?.product_data?.plumbing_data?.vaccumDental, itemData?.product?.plumbing_data?.vaccumDental),
                medicalGas: handleUndefined(itemData?.product_data?.plumbing_data?.medicalGas, itemData?.product?.plumbing_data?.medicalGas),
                gasType: handleUndefined(itemData?.product_data?.plumbing_data?.gasType, itemData?.product?.plumbing_data?.gasType),
                gasLocation: handleUndefined(itemData?.product_data?.plumbing_data?.gasLocation, itemData?.product?.plumbing_data?.gasLocation),
            }
        }
    });

    const handleClose = () => {
        setOpen(false);
        getInitialData();
    }

    const handleKeyDown = (event) => {
        if (!contentRef.current) return;

        const { key } = event;
        if (key === 'ArrowDown') {
            contentRef.current.scrollBy({
                top: 100,
                behavior: 'smooth',
            });
        } else if (key === 'ArrowUp') {
            contentRef.current.scrollBy({
                top: -100,
                behavior: 'smooth',
            });
        }
    };

    const handleMouseWheel = (event) => {
        if (!contentRef.current) return;

        // Check the delta of the mouse wheel movement
        const scrollAmount = event.deltaY;

        // Smoothly scroll based on the wheel direction
        contentRef.current.scrollBy({
            top: scrollAmount,
            behavior: 'smooth',
        });

        // Prevent the default behavior to avoid the page scrolling
        event.preventDefault();
    };

    useEffect(() => {
        window.addEventListener('keydown', handleKeyDown);
        window.addEventListener('wheel', handleMouseWheel, { passive: false });  // Add wheel event listener for mouse scroll

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
            window.removeEventListener('wheel', handleMouseWheel);
        };
    }, []);


    const handleTabChange = (event, newValue) => {
        setSelectedTab(newValue);
        const section = document.getElementById(`section${newValue + 1}`);
        if (section) {
            section.scrollIntoView({ behavior: 'smooth' });
        }
    };

    const handleSubmit = async () => {
        try {
            if (items?.quantity > 0) {
                setDataLoading(true);
                if (itemData.product_id !== items?.product_id) {
                    const responseProduct = await apiRequest('get', `/product/${items?.product_id}`);
                    items.unit_price = Number(responseProduct?.data?.data?.list_price);
                } else {
                    items.unit_price = Number(items?.unit_price);
                }
                const response = await apiRequest('put', `/project-item/${itemData?.item_id}`, {
                    ...items,
                    tax: Number(items?.tax),
                    quantity: Number(items?.quantity),
                    freight: Number(items.freight),
                    fees: Number(items?.fees),
                    storage: Number(items?.storage),
                    installation: Number(items?.installation),
                    discounts: Number(items?.discounts),
                    tradein: Number(items?.tradein),
                    phase_date: items?.phase_date !== null ? moment(items?.phase_date).format('YYYY-MM-DDThh:mm:ssZ') : null,
                    need_by_date: items?.need_by_date !== null ? moment(items?.need_by_date).format('YYYY-MM-DDThh:mm:ssZ') : null
                });
                if (response.data) {
                    handleClose();
                    getInitialData();
                    showNotification(response.data.message, 'success');
                }
            } else {
                showNotification('Item Quantity is must be greater than 0', 'error');
            }
        } catch (error) {
            setDataLoading(false);
            showNotification(error?.response?.data.error || error.message, 'error');
        }
    }

    return (
        <Drawer
            anchor="bottom"
            open={open}
            sx={{
                '& .MuiDrawer-paper': {
                    height: '88%',
                }
            }}
        >
            {dataLoading && (<LoadingPage isLoading={dataLoading} />)}
            <DemoBox1>
                <Box style={{ width: '70%' }}>
                    <Box style={{
                        padding: '5px 0px 5px 25px',
                        margin: '10px -24px 0px -24px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 10
                    }}>
                        <Typography variant='body1' style={{ fontWeight: 'bold' }}>Edit Item</Typography>
                        <Link
                            style={{ textDecoration: 'none', cursor: 'pointer', fontSize: 12, color: 'gray' }}
                            color="inherit"
                        >
                            Project Hierarchy :
                        </Link>
                        <Box display="flex" alignItems="center" gap={0.5}>
                            <BusinessIcon style={{ fontSize: 18, color: 'gray' }} />
                            <Link
                                style={{ textDecoration: 'none', cursor: 'pointer', fontSize: 12, color: 'gray' }}
                                color="inherit"
                            >
                                {projectData?.name}
                            </Link>
                        </Box>
                        {itemData?.building !== null && (
                            <Box display="flex" alignItems="center" gap={0.5}>
                                <LocationCityIcon style={{ fontSize: 18, color: 'gray' }} />
                                <Link
                                    style={{ textDecoration: 'none', cursor: 'pointer', fontSize: 12, color: 'gray' }}
                                    color="inherit"
                                >
                                    {itemData?.building?.building_name}
                                </Link>
                            </Box>
                        )}
                        {itemData?.level !== null && (
                            <Box display="flex" alignItems="center" gap={0.5}>
                                <ApartmentIcon style={{ fontSize: 18, color: 'gray' }} />
                                <Link
                                    style={{ textDecoration: 'none', cursor: 'pointer', fontSize: 12, color: 'gray' }}
                                    color="inherit"
                                >
                                    {itemData?.level?.level_name}
                                </Link>
                            </Box>
                        )}
                        {itemData?.department !== null && (
                            <Box display="flex" alignItems="center" gap={0.5}>
                                <ViewComfyIcon style={{ fontSize: 18, color: 'gray' }} />
                                <Link
                                    style={{ textDecoration: 'none', cursor: 'pointer', fontSize: 12, color: 'gray' }}
                                    color="inherit"
                                >
                                    {itemData?.department?.department_name}
                                </Link>
                            </Box>
                        )}
                        {itemData?.room !== null && (
                            <Box display="flex" alignItems="center" gap={0.5}>
                                <MeetingRoomIcon style={{ fontSize: 18, color: 'gray' }} />
                                <Link
                                    style={{ textDecoration: 'none', cursor: 'pointer', fontSize: 12, color: 'gray' }}
                                    color="inherit"
                                >
                                    {itemData?.room?.room_name}
                                </Link>
                            </Box>
                        )}
                        <Box display="flex" alignItems="center" gap={0.5}>
                            <SellIcon color="primary" style={{ fontSize: 16 }} />
                            <Typography color="primary" style={{ fontSize: 12 }}>{itemData?.product_data?.model ? itemData?.product_data?.model : itemData?.product?.model !== 'null' ? itemData?.product?.model !== null ? itemData?.product?.model : 'UnSpecified' : 'UnSpecified'}</Typography>
                        </Box>
                    </Box>
                </Box>
                <Box>
                    <Button
                        variant='outlined'
                        size="small"
                        style={{
                            textTransform: 'capitalize',
                            marginRight: '8px'
                        }}
                        startIcon={<Cached />}
                        onClick={() => {
                            setItems((prevData) => ({
                                ...prevData,
                                unit_price: itemData?.product?.list_price,
                                product_data: {
                                    ...prevData.product_data,
                                    type: itemData?.product?.type,
                                    price_type: undefined,
                                    catalog: itemData?.product?.catalog,
                                    vendor_id: itemData?.product?.vendor?.product_provider_id,
                                    vendor: {
                                        name: itemData?.product?.vendor?.name
                                    },
                                    life_expectancy: itemData?.product?.life_expectancy,
                                    lead_time: itemData?.product?.lead_time,
                                    furnish_responsibility: itemData?.product?.furnish_responsibility,
                                    install_responsibility: itemData?.product?.install_responsibility,
                                    architectural_code: itemData?.product?.architectural_code,
                                    international: itemData?.product?.international,
                                    architecturally_significant: itemData?.product?.architecturally_significant,
                                    spatially_significant: itemData?.product?.spatially_significant,
                                    tech_connection_data: {
                                        isConnection: itemData?.product?.tech_connection_data?.isConnection,
                                        connectionType: itemData?.product?.tech_connection_data?.connectionType,
                                        network: itemData?.product?.tech_connection_data?.network,
                                        techRemarks: itemData?.product?.tech_connection_data?.techRemarks
                                    },
                                    description: itemData?.product?.description,
                                    adjustable_width: itemData?.product?.adjustable_width,
                                    adjustable_height: itemData?.product?.adjustable_height,
                                    adjustable_depth: itemData?.product?.adjustable_depth,
                                    width: itemData?.product?.width,
                                    height: itemData?.product?.height,
                                    depth: itemData?.product?.depth,
                                    mounting: itemData?.product?.mounting,
                                    max_weight: itemData?.product?.max_weight,
                                    ship_weight: itemData?.product?.ship_weight,
                                    clearance: {
                                        left: itemData?.product?.clearance?.left,
                                        right: itemData?.product?.clearance?.right,
                                        front: itemData?.product?.clearance?.front,
                                        back: itemData?.product?.clearance?.back,
                                        top: itemData?.product?.clearance?.top,
                                        bottom: itemData?.product?.clearance?.bottom
                                    },
                                    da_complient: itemData?.product?.da_complient,
                                    antimicrobial: itemData?.product?.antimicrobial,
                                    green: itemData?.product?.green,
                                    seismic: itemData?.product?.seismic,
                                    Shielding: itemData?.product?.Shielding,
                                    spatial_remarks: itemData?.product?.spatial_remarks,
                                    mechanical_data: {
                                        heatDissipation: itemData?.product?.mechanical_data?.heatDissipation,
                                        dissipationType: itemData?.product?.mechanical_data?.dissipationType,
                                        vent: itemData?.product?.mechanical_data?.vent,
                                        ventType: itemData?.product?.mechanical_data?.ventType,
                                        mechanicalRemarks: itemData?.product?.mechanical_data?.mechanicalRemarks
                                    },
                                    electrical_data: {
                                        voltageType: itemData?.product?.electrical_data?.voltageType,
                                        volts: itemData?.product?.electrical_data?.volts,
                                        amps: itemData?.product?.electrical_data?.amps,
                                        hertz: itemData?.product?.electrical_data?.hertz,
                                        watts: itemData?.product?.electrical_data?.watts,
                                        kva: itemData?.product?.electrical_data?.kva,
                                        electricalPhase: itemData?.product?.electrical_data?.electricalPhase,
                                        plugtype: itemData?.product?.electrical_data?.plugtype,
                                        plugdetail: itemData?.product?.electrical_data?.plugdetail,
                                        dedicatedCircuit: itemData?.product?.electrical_data?.dedicatedCircuit,
                                        emergencyPower: itemData?.product?.electrical_data?.emergencyPower,
                                        remoteTrans: itemData?.product?.electrical_data?.remoteTrans,
                                        remoteSwitch: itemData?.product?.electrical_data?.remoteSwitch,
                                        electricalRemarks: itemData?.product?.electrical_data?.electricalRemarks
                                    },
                                    plumbing_data: {
                                        plumbingRemarks: itemData?.product?.plumbing_data?.plumbingRemarks,
                                        hotWater: itemData?.product?.plumbing_data?.hotWater,
                                        coldWater: itemData?.product?.plumbing_data?.coldWater,
                                        treatedWater: itemData?.product?.plumbing_data?.treatedWater,
                                        drain: itemData?.product?.plumbing_data?.drain,
                                        drainLocation: itemData?.product?.plumbing_data?.drainLocation,
                                        steam: itemData?.product?.plumbing_data?.steam,
                                        vaccumMedical: itemData?.product?.plumbing_data?.vaccumMedical,
                                        vaccumDental: itemData?.product?.plumbing_data?.vaccumDental,
                                        medicalGas: itemData?.product?.plumbing_data?.medicalGas,
                                        gasType: itemData?.product?.plumbing_data?.gasType,
                                        gasLocation: itemData?.product?.plumbing_data?.gasLocation,
                                    }
                                }
                            }));
                        }}
                    >
                        Reset All
                    </Button>
                    <Button
                        variant='contained'
                        size="small"
                        style={{
                            textTransform: 'capitalize'
                        }}
                        onClick={() => handleSubmit()}
                    >
                        Save
                    </Button>
                    <IconButton onClick={() => handleClose()}>
                        <ClearIcon />
                    </IconButton>
                </Box>
            </DemoBox1>
            <Divider />
            <Box display="flex">
                <Box
                    sx={{
                        height: '100%',
                        position: 'sticky',
                        top: 0,
                        paddingLeft: 1,
                        paddingTop: 1,
                    }}
                >
                    <Typography sx={{ fontSize: 13, fontWeight: 'bold' }}>Quick Navigation</Typography>
                    <Tabs
                        orientation="vertical"
                        value={selectedTab}
                        onChange={handleTabChange}
                        aria-label="Vertical tabs example"
                        sx={{
                            borderRight: 1,
                            borderColor: 'divider',
                            minWidth: 110,
                        }}
                    >
                        <Tab label="Item Details" sx={{ fontSize: 10, py: 0.1, minHeight: 20, padding: 0, alignItems: 'flex-start' }} />
                        <Tab label="Financial" sx={{ fontSize: 10, py: 0.1, minHeight: 20, padding: 0, alignItems: 'flex-start' }} />
                        <Tab label="Responsibility/Significant" sx={{ fontSize: 10, py: 0.1, minHeight: 20, padding: 0, alignItems: 'flex-start' }} />
                        <Tab label="Physical Specifications" sx={{ fontSize: 10, py: 0.1, minHeight: 20, padding: 0, alignItems: 'flex-start' }} />
                        <Tab label="MEP Specifications" sx={{ fontSize: 10, py: 0.1, minHeight: 20, padding: 0, alignItems: 'flex-start' }} />
                        <Tab label="Tech Connection" sx={{ fontSize: 10, py: 0.1, minHeight: 20, padding: 0, alignItems: 'flex-start' }} />
                    </Tabs>
                </Box>
                <Box
                    ref={contentRef}
                    sx={{
                        flexGrow: 1,
                        overflowY: 'hidden',
                        height: '77vh',
                        paddingRight: 1
                    }}>
                    <section id="section1" style={{ paddingTop: 10, paddingLeft: 10 }}>
                        <ItemInformation
                            itemData={itemData}
                            projectData={projectData}
                            items={items}
                            setItems={setItems}
                        />
                    </section>
                    <section id="section2" style={{ paddingTop: 10, paddingLeft: 10 }}>
                        <FinancialDetails
                            itemData={itemData}
                            projectData={projectData}
                            items={items}
                            setItems={setItems}
                        />
                    </section>
                    <section id="section3" style={{ paddingTop: 10, paddingLeft: 10 }}>
                        <Responsibilities
                            itemData={itemData}
                            items={items}
                            setItems={setItems}
                        />
                    </section>
                    <section id="section4" style={{ paddingTop: 10, paddingLeft: 10 }}>
                        <Physical
                            itemData={itemData}
                            items={items}
                            setItems={setItems}
                            projectData={projectData}
                        />
                    </section>
                    <section id="section5" style={{ paddingTop: 10, paddingLeft: 10 }}>
                        <MEP
                            itemData={itemData}
                            items={items}
                            setItems={setItems}
                            projectData={projectData}
                        />
                    </section>
                    <section id="section6" style={{ paddingTop: 10, paddingLeft: 10 }}>
                        <TechConnection
                            itemData={itemData}
                            items={items}
                            setItems={setItems}
                        />
                    </section>
                </Box>
            </Box>
        </Drawer>
    )
}

export default EditItem;